import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../layouts/nav/LanguageSwitcher";
// image
import logo from "../../images/ensss_logo.png";


const LockScreen = ({ history }) => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const submitHandler = (e) => {
    e.preventDefault();
    nav("/dashboard");
  };
  return (
    <div className="authincation h-100 ">
      <div className="container vh-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                      <div className="text-end mb-2">
                        <LanguageSwitcher as="div" className="d-inline-block" toggleClassName="i-false c-pointer d-inline-flex align-items-center text-muted" />
                      </div>
                      <div className="text-center mb-3">
                        <Link to="/dashboard">
                          <img className="logo-abbr text-center m-auto" width="200" src={logo} alt="ENSSS QCM Logo" />
                        </Link>
                      </div>
                    <h4 className="text-center mb-4 ">{t('pages.lockScreen.title')}</h4>
                    <form onSubmit={(e) => submitHandler(e)}>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>{t('common.fields.password')}</strong>
                        </label>
                        <input
                            type="password"
                            className="form-control"
                            defaultValue={t('common.fields.password')}
                        />
                      </div>
                      <div className="text-center">
                        <button
                            type="submit"
                            className="btn btn-primary btn-block"
                        >
                           {t('pages.lockScreen.unlock')}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;